<template>
  <v-dialog :value="visible" persistent width="30%">
    <v-card :color="color" dark>
      <v-card-title primary-title>
        <strong>{{ title }}</strong>
        <v-spacer></v-spacer>
        <v-icon v-if="color === successColor">done</v-icon>
        <v-icon v-if="color === errorColor">error</v-icon>
      </v-card-title>
      <v-card-text>
        <v-progress-linear
          v-if="color !== errorColor && color !== successColor"
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
        <ul>
          <li v-for="error in errors" :key="error">{{ error }}</li>
        </ul>
      </v-card-text>
      <v-card-actions v-if="color === errorColor">
        <v-spacer></v-spacer>
        <v-btn @click="close" text transparent>Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["progressMessage", "successMessage", "errorMessage"],
  data() {
    return {
      visible: false,
      title: "",
      errors: [],
      color: "primary",
      errorColor: "red darken-4",
      successColor: "green darken-1"
    };
  },
  methods: {
    show() {
      this.title = this.progressMessage;
      this.color = "primary";
      this.visible = true;
    },
    succeed() {
      if (this.successMessage) {
        this.title = this.successMessage;
        this.color = this.successColor;
        setTimeout(this.close, 800);
      } else {
        setTimeout(this.close, 200);
      }
    },
    fail(errors) {
      this.title = this.errorMessage;
      this.color = this.errorColor;
      this.errors = errors;
    },
    close() {
      this.errors = [];
      this.visible = false;
    }
  }
};
</script>
